module.exports = __webpack_public_path__ + "static/sofia-003-a6a6f5de6290235851cfa897f47be711.jpg";